import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import toast from "react-hot-toast";
import Chart from "react-apexcharts";

import { format } from "date-fns";
import { es } from "date-fns/locale"; // Or any other locale like 'de', 'es', etc.

import "../daterangepicker.css";
import "../Usuarios/usuarios.css";
import "../../Forms.css";

import * as api from "helper/helper";
import { Sections } from "../../data/navItem";
import { PermissionsForSection } from "../auth";

import { getMonthNames, Singleton, truncateToTwoDecimals } from "helper/tools";

import Gauge from "./Gauges/Gauge";
import { NivelOptions } from "../../helperFunctions/helpers";

const ReportsComparaSmall = forwardRef((props, ref) => {
  const monthSelectedIndex = useRef();
  const yearSelected = useRef();

  const [ordenes, setOrdenes] = useState({ actual: 0, perc: 0, last: 0 });
  const [ventas, setVentas] = useState({ actual: 0, perc: 0, last: 0 });
  const [asociados, setAsociados] = useState({
    actual: 0,
    perc: 0,
    last: 0,
  });
  const [productos, setProductos] = useState({
    actual: 0,
    perc: 0,
    last: 0,
  });
  const [ticketPromedio, setTicketPromedio] = useState({
    actual: 0,
    perc: 0,
    last: 0,
  });

  const [metasNiveles, setMetasNiveles] = useState([]);

  const [chartType] = useState("line");

  const [series, setSeries] = useState([
    {
      data: [],
      name: "Ventas",
    },
  ]);

  const [options, setOptions] = useState({
    chart: {
      height: 350,
      type: "line",
      toolbar: {
        show: false,
      },
    },

    markers: {
      size: 5,
      hover: {
        size: 9,
      },
    },

    colors: ["#8cc5e350", "#5db2e3ff", "#2066a8"],
    //colors: ["purple", "#00E396", "#CED4DC"],
    /*markers: { size: 4 },*/

    fill: {
      type: "gradient",
      gradient: {
        type: "vertical",
        inverseColors: false,
        shade: "light",
        gradientToColors: ["#E6F7FF"],
        /*shadeIntensity: 0.5,
        opacityFrom: 0.2,
        opacityTo: 1,*/
        //  stops: [0, 100, 100, 100],
      },
    },

    dataLabels: {
      enabled: false,
    },
    //stroke: { curve: "smooth", width: 2 },
    xaxis: {
      type: "category",
      labels: {
        datetimeUTC: false,
      },
    },
    yaxis: {
      labels: {
        /**
         * Allows users to apply a custom formatter function to yaxis labels.
         *
         * @param { String } value - The generated value of the y-axis tick
         * @param { index } index of the tick / currently executing iteration in yaxis labels array
         */
        formatter: function (val, index) {
          //  console.log("<<<<<< " + val);
          if (val == null) return "?";
          return Singleton.getInstance().format(val); //val.toFixed(2);
        },
      },
    },
    title: {
      text: "",
    },
    tooltip: {
      x: {
        /*format: "dd/MM/YYYY",*/
        formatter: function (e, data, t) {
          console.log(`x <<< ${e} ${data}`);

          if (monthSelectedIndex.current == null) return "";
          // dataPointIndex is 0 based, Date Object Date is 1 based
          let dayOrd = data.dataPointIndex + 1;
          const start = new Date();
          start.setMonth(monthSelectedIndex.current);
          start.setDate(dayOrd);
          start.setFullYear(yearSelected.current);
          //const fechaInicial = format(start, "yyyy-MM-dd'T'00:00:00");
          const fechaInicial = format(start, "dd EEEE yyyy", { locale: es });
          //
          //monthSelected
          return fechaInicial;
        },
      },
      y: {},
    },
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMetaMensual, setIsLoadingMetaMensual] = useState(false);
  const [isLoadingMetaHoy, setIsLoadingMetaHoy] = useState(false);
  const [isLoadingMetasNivel, setIsLoadingMetasNivel] = useState(false);

  const [metaDiaria, setMetaDiaria] = useState(0);
  const [metaMes, setMetaMes] = useState(0);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [months, setMonths] = useState([]);

  /** FILTERS */
  useImperativeHandle(ref, () => ({
    getValue: () => {
      return "formik.values";
    },
    changeSelectedMonth: (monthIndex, year) => {
      console.trace();
      monthSelectedIndex.current = monthIndex;
      yearSelected.current = year;
      fetchData(monthIndex, year);
    },
  }));

  useEffect(() => {
    const wideMonthNames = getMonthNames(es).map((month) => ({
      name: month,
      isSelected: false,
    }));
    setMonths(wideMonthNames);

    //fetchData();

    const newPermissions = PermissionsForSection(Sections.Asociados);
    setPermissions(newPermissions);
  }, []);
  /*
  useEffect(() => {
    //preselect month
    const date = new Date();

    const monthIndex = date.getMonth();
    //monthSelectRef.current.value = monthIndex;
    //fetchData(monthIndex);
  }, [months]);*/

  const arrayRange = (start, stop, step) =>
    Array.from(
      { length: (stop - start) / step + 1 },
      (value, index) => start + index * step,
    );

  const getDaysForMonth = (monthIndex) => {
    const date = new Date();
    const daysCount = daysInMonth(monthIndex, date.getFullYear()); // 31
    return daysCount;
  };

  const getDaysForMonthNormalize = (monthIndex) => {
    const monthIndexFix = parseInt(monthIndex);
    const daysCount = getDaysForMonth(monthIndexFix); // 31

    let dayRange = arrayRange(1, daysCount, 1);

    return dayRange;
  };

  // Month in JavaScript is 0-indexed (January is 0, February is 1, etc),
  // but by using 0 as the day it will give us the last day of the prior
  // month. So passing in 1 as the month number will return the last day
  // of January, not February
  function daysInMonth(monthIndex, year) {
    return new Date(year, monthIndex + 1, 0).getDate();
  }

  const fetchData = async (monthIndex, year) => {
    const start = new Date();
    start.setMonth(monthIndex);
    start.setDate(1);
    start.setFullYear(year);

    const end = new Date(start);
    end.setMonth(start.getMonth() + 1);
    end.setDate(0);

    const fechaInicial = format(start, "yyyy-MM-dd'T'00:00:00");
    const fechaFinal = format(end, "yyyy-MM-dd'T'23:59:59");

    const payload = {
      startDate: fechaInicial,
      endDate: fechaFinal,
      periodo: "dia",
    };

    setIsLoading(true);
    setIsLoadingMetasNivel(true);
    setIsLoadingMetaHoy(true);
    setIsLoadingMetaMensual(true);

    /*
  {
  "startDate": "2025-08-16T03:51:12.244Z",
  "endDate": "2025-08-16T03:51:12.244Z",
  "periodo": "string",
  "top": 0
}
    */

    loadMetaBuilder(start, end);

    /** */
    const response = await api
      .dashboardVentasPorPeriodoComparativa(payload)
      .catch((error) => {
        toast.error("Error al Ventas por Periodo Comparativa.");
        setIsLoading(false);
      });

    setIsLoading(false);
    if (!response) {
      return;
    }

    const daysRange = getDaysForMonthNormalize(monthIndex);

    const INVALID_VALUE = null;
    const series = [];
    let indexX = 0;
    for (const [key, value] of Object.entries(response.data)) {
      let offset = 0;
      let newDatas = daysRange.map((day, index) => {
        if (offset >= value.length) {
          return INVALID_VALUE;
        }
        const item = value[offset];
        const dayRight = new Date(item.periodo).getDate();

        if (dayRight !== day) {
          return 0;
        }
        offset++;

        return item.total;
      });

      //newDatas = newDatas.filter((value) => value !== INVALID_VALUE);

      series.push({
        name: key,
        data: newDatas,
        type: indexX % 2 === 0 ? "bar" : "line",
      });

      indexX++;
    }

    //currentMetaCalc(series);

    const newOptions = { ...options };
    newOptions.chart.type = "area";

    const daysCount = getDaysForMonth(monthIndex); // 31

    // metas
    //const dateRaw = start.toJSON();

    const responseMetasMonthDaily = await api
      .getMonthMetasVentasDiaria(fechaInicial)
      .catch((error) => {
        toast.error("Error al pedir Niveles.");
        setIsLoading(false);
      });

    if (!responseMetasMonthDaily) {
      setIsLoading(false);
      return;
    }

    setIsLoading(false);

    //ORO
    const dataMonthDaily = responseMetasMonthDaily.data;
    console.log("");

    const days = [];
    const metasA = [];
    dataMonthDaily.forEach((daily) => {
      /*const utcDate = parseJSON(daily.fecha);
      days.push(utcDate.getDate());*/
      const utcDate = new Date(daily.fecha);
      days.push(utcDate.getDate());
      metasA.push(daily.meta === 0 || daily.meta == null ? null : daily.meta);
    });

    //const dataNew = { ...data };
    //dataNew.labels = days;

    //
    let metas = [
      100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000,
      100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000,
      100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000, 100000,
      100000, 100000, 100000, 100000,
    ];

    let endIndex = metas.length - daysCount;
    if (endIndex === 0) {
      endIndex = metas.length;
    } else {
      endIndex = metas.length - endIndex;
    }

    //  let newMetas = metas.slice(0, endIndex);

    const series1 = [
      //newOptions.series = [
      {
        name: "Meta Diaria",
        data: metasA, // data: newMetas,
        type: "area",
      },

      ...series,
    ];

    newOptions.dataLabels = {
      enabled: false,
    };

    newOptions.stroke = {
      width: [2, 3, 3],
      curve: "straight",
      //  dashArray: [0, 8, 5],
    };

    /*  newOptions.title = {
      text: "Estadisticas",
      align: "left",
    };*/

    newOptions.legend = {
      /*  tooltipHoverFormatter: function (val, opts) {
        const serie = opts.w.globals.series[opts.seriesIndex];
        const desc = serie[opts.dataPointIndex] ?? null;
        let final = "?";
        if (desc != null) final = Singleton.getInstance().format(desc);

        const re = `${val} - <strong>${final}</strong>`;

        //console.log("---> " + re);

        return re;

        /*return (
          val +
          " - <strong>" +
          opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex] +
          "</strong>"
        );/
      },*/
    };

    /* TODOnewOptions.markers = {
      size: 0,
      hover: {
        sizeOffset: 1,
      },
    };*/

    /*
    obtener dias del mes
    */

    newOptions.xaxis = {
      type: "category",
      categories: daysRange,
      /*  tooltip: {
        y: [
          {
            title: {
              formatter: function (val) {
                return val + " (mins)";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val + " per session";
              },
            },
          },
          {
            title: {
              formatter: function (val) {
                return val;
              },
            },
          },
        ],
      },*/
      grid: {
        borderColor: "#f1f1f1",
      },
    };
    /*
    newOptions.tooltip = {
      x: {
        format: "dd/MM/yy HH:mm",
      },
    };*/

    //setChartType(graphModeRef.current);
    setOptions({ ...newOptions });
    setSeries([...series1]);
  };

  function getActualLastYear(datas, thisYear, lastYear) {
    const dataActualYear =
      datas.find((e) => e.periodo === thisYear)?.total ?? 0;
    const dataLastYear = datas.find((e) => e.periodo === lastYear)?.total ?? 0;

    let dataActualPerc = 0;
    if (dataLastYear != null && dataLastYear > 0) {
      dataActualPerc = truncateToTwoDecimals(dataActualYear / dataLastYear);
    }

    return {
      actual: dataActualYear,
      last: dataLastYear,
      perc: dataActualPerc,
    };
  }

  async function loadMetaBuilder(start, end) {
    /*
    si es el mes actual mostrar solo lo transcurrido al 
    dia
    */
    const now = new Date();
    now.setHours(0);
    now.setMinutes(0);
    now.setSeconds(0);

    const newEnd = new Date(end);
    end.setHours(0);
    end.setMinutes(0);
    end.setSeconds(0);

    let currentMonth = false;
    if (
      now.getFullYear() === newEnd.getFullYear() &&
      now.getMonth() === newEnd.getMonth()
    ) {
      newEnd.setDate(now.getDate());
      currentMonth = true;
    }

    const fechaInicial = format(start, "yyyy-MM-dd'T'00:00:00");
    const fechaFinal = format(newEnd, "yyyy-MM-dd'T'23:59:59");
    const fechaHoy = format(now, "yyyy-MM-dd'T'00:00:00");

    const payload = {
      startDate: fechaInicial,
      endDate: fechaFinal,
    };

    const responseCards = await api
      .dashboardVentasPorPeriodoComparativaTarjetas(payload)
      .catch((error) => {
        toast.error("Error al pedir Comparativa Tarjetas.");
        setIsLoading(false);
      });

    setIsLoading(false);
    if (!responseCards) {
      return;
    }
    //---
    const thisYear = start.getFullYear();
    const lastYear = thisYear - 1;

    /* */
    const ordenes = responseCards.data.Ordenes;
    const ventas = responseCards.data.Ventas;
    const asociados = responseCards.data.Asociados;
    const productos = responseCards.data.Productos;
    const ticketProm = responseCards.data.TicketPromedio;
    setOrdenes(getActualLastYear(ordenes, thisYear, lastYear));
    setVentas(getActualLastYear(ventas, thisYear, lastYear));
    setAsociados(getActualLastYear(asociados, thisYear, lastYear));
    setProductos(getActualLastYear(productos, thisYear, lastYear));
    setTicketPromedio(getActualLastYear(ticketProm, thisYear, lastYear));

    const responseMetaMonth = await api
      .getMonthMetasVentasMonth(fechaInicial)
      .catch((error) => {
        toast.error("Error al pedir Niveles.");
        setIsLoadingMetaMensual(false);
      });

    setIsLoadingMetaMensual(false);
    if (!responseMetaMonth) {
      return;
    }

    setMetaMes(responseMetaMonth.data.meta);

    ///
    let responseMetaHoy = 0;
    if (currentMonth) {
      responseMetaHoy = await api.metaVentaDia(fechaHoy).catch((error) => {
        toast.error("Error al pedir Meta Dia Actual.");
        setIsLoadingMetaHoy(false);
      });
      responseMetaHoy = responseMetaHoy?.data?.meta ?? 0;
    }

    setIsLoadingMetaHoy(false);
    if (responseMetaHoy === null) {
      return;
    }

    setMetaDiaria(responseMetaHoy);

    getMetasNiveles(fechaInicial);
  }

  async function getMetasNiveles(fechaInicial) {
    //
    const responseMetasNiveles = await api
      .getMetasVentasNivel(fechaInicial)
      .catch((error) => {
        toast.error("Error al pedir Metas.");
        setIsLoadingMetasNivel(false);
      });

    setIsLoadingMetasNivel(false);
    if (responseMetasNiveles == null) {
      toast.error("Error al pedir las Metas.");
      return;
    }

    // NIVELES METAS
    const metaNivelData = responseMetasNiveles.data;
    const oro = metaNivelData.find(
      (value, index) => value.nivelId === NivelOptions.ORO.id,
    );
    const plata = metaNivelData.find(
      (value, index) => value.nivelId === NivelOptions.PLATA.id,
    );
    const bronce = metaNivelData.find(
      (value, index) => value.nivelId === NivelOptions.BRONCE.id,
    );

    //TODO: esperar que emma mande los demas
    setMetasNiveles([
      { name: "Oro", value: Singleton.getInstance().format(oro?.meta ?? 0) },
      {
        name: "Plata",
        value: Singleton.getInstance().format(plata?.meta ?? 0),
      },
      {
        name: "Bronce",
        value: Singleton.getInstance().format(bronce?.meta ?? 0),
      },
    ]);
  }

  return (
    <>
      <div className="">
        <div className="d-flex justify-content-center flex-row mb-3">
          <div className="d-flex flex-row column-gap-3">
            <Gauge
              title="Ventas"
              desc={ventas.actual}
              perCompareVenta={ventas.perc}
              loading={isLoading}
            />
            <Gauge
              title="Ordenes"
              desc={ordenes.actual}
              perCompareVenta={ordenes.perc}
              descIsCurrency={false}
              loading={isLoading}
            />
            <Gauge
              title="Asociados"
              desc={asociados.actual}
              perCompareVenta={asociados.perc}
              descIsCurrency={false}
              loading={isLoading}
            />
            <Gauge
              title="Productos"
              desc={productos.actual}
              perCompareVenta={productos.perc}
              descIsCurrency={false}
              loading={isLoading}
            />
          </div>
        </div>

        <div className="d-flex justify-content-center flex-row mb-3">
          <div className="d-flex flex-row column-gap-3">
            {/*<div className="mb-auto p-2">Flex item</div>
            <div className="p-2">Flex item</div>
            <div className="p-2">Flex item</div>*/}
            <Gauge
              title="Meta Mensual"
              desc={metaMes}
              loading={isLoadingMetaMensual}
              showPercentaje={false}
            />
            <Gauge
              title="Meta Diaria"
              desc={metaDiaria}
              descIsCurrency={true}
              loading={isLoadingMetaHoy}
              showPercentaje={false}
            />
            <Gauge
              title="Metas Niveles"
              loading={isLoadingMetasNivel}
              multiLine={true}
              multiLineValues={metasNiveles}
            />
            <Gauge
              title="Ticket Promedio"
              desc={ticketPromedio.actual}
              perCompareVenta={ticketPromedio.perc}
              descIsCurrency={false}
              loading={isLoading}
            />
          </div>
        </div>

        <div className="bd-example-row1">
          <div className="row">
            <div className="p-3 border bg-primary text-light report-card-title">
              <span>
                Comparativa Ventas
                <small className="text-muted"></small>
              </span>
            </div>
          </div>

          <div className="row">
            <Chart
              options={options}
              series={series}
              type={chartType}
              height={options.chart.height}
            />
          </div>
        </div>
      </div>
    </>
  );
});

export default ReportsComparaSmall;
